import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {EnableAIGuide} from "./__graphql-types__/EnableAIGuide.ts";

type Variables = {
    kaid: string;
};

export const ENABLE_AI_GUIDE_MUTATION: GqlOperation<EnableAIGuide, Variables> =
    gqlOp(gql`
        mutation EnableAIGuide($kaid: String!) {
            enableAIGuide(kaid: $kaid) {
                error {
                    code
                    debugMessage
                }
            }
        }
    `);
